module.exports = __webpack_public_path__ + "img/logo.c34bb8e1.png";